export const Logo = ({ className = "", ...props }) => {
    return (
        <img
            src="/logo_main.webp"
            alt="Logo"
            className={`h-1/6 object-contain ${className}`}
            {...props}
        />
    );
};
export default Logo;